import { fileSchema, locationSchema } from "@/types/schema";
import * as z from "zod";

export const registerSchema = z
  .object({
    firstName: z.string().min(1, "Required"),
    lastName: z.string().min(1, "Required"),
    email: z.string().min(1, "Required"),
    password: z.string().min(6, "Password should contain 6 or more characters"),
    confirmPassword: z
      .string()
      .min(6, "Password should contain 6 or more characters"),
    locationDetail: z.string().optional(),
    distanceRadius: z.number().optional(),
    location: locationSchema.optional(),
    profileImage: fileSchema.nullish(),
    isTermsAccepted: z.boolean(),
  })
  .superRefine(({ confirmPassword, password, isTermsAccepted }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        code: "custom",
        message: "Password and confirm password should be same",
        path: ["confirmPassword"],
      });
    }
    if (!isTermsAccepted) {
      ctx.addIssue({
        code: "custom",
        message: "Please accept terms",
        path: ["isTermsAccepted"],
      });
    }
  });

export type RegisterSchemaModel = z.infer<typeof registerSchema>;

export const merchantRegisterSchema = z
  .object({
    businessName: z.string().min(1, "Required"),
    businessAddress: z.string().min(1, "Required"),
    firstName: z.string().min(1, "Required"),
    lastName: z.string().min(1, "Required"),
    email: z.string().min(1, "Required"),
    password: z.string().min(6, "Password should contain 6 or more characters"),
    confirmPassword: z
      .string()
      .min(6, "Password should contain 6 or more characters"),
    websiteUrl: z.string().optional(),
    categoryId: z.string().optional(),
    profileImage: fileSchema.nullish(),
    isTermsAccepted: z.boolean(),
  })
  .superRefine(({ confirmPassword, password, isTermsAccepted }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        code: "custom",
        message: "Password and confirm password should be same",
        path: ["confirmPassword"],
      });
    }
    if (!isTermsAccepted) {
      ctx.addIssue({
        code: "custom",
        message: "Please accept terms",
        path: ["isTermsAccepted"],
      });
    }
  });

export type MerchantRegisterSchemaModel = z.infer<
  typeof merchantRegisterSchema
>;
